import React from 'react';
import { ReactFlowProvider } from 'reactflow';
import 'reactflow/dist/style.css';
import '../index.css';
import EntitlementEditor from './EntitlementEditor';
import { RepositoryProvider } from '../contexts/RepositoryContext';
import { MockRepository } from '../repositories/dummyData';
import { EntitlementObject, ContextMenuItem } from '../types';

interface EntitlementEditorWrapperProps {
  initialData: EntitlementObject;
  onSave?: (data: EntitlementObject) => void;
  onSaveAndReturn?: (data: EntitlementObject) => void;
  onBack?: () => void;
  onLoadRequest?: () => void;
  additionalCanvasMenuItems?: ContextMenuItem[];
  additionalNodeMenuItems?: (node: any) => ContextMenuItem[];
}

const EntitlementEditorWrapper: React.FC<EntitlementEditorWrapperProps> = ({
  initialData,
  onSave,
  onSaveAndReturn,
  onBack,
  onLoadRequest,
  additionalCanvasMenuItems,
  additionalNodeMenuItems
}) => {
  return (
    <ReactFlowProvider>
      <EntitlementEditor 
        key={initialData.Name} 
        initialData={initialData}
        onSave={onSave}
        onSaveAndReturn={onSaveAndReturn}
        onBack={onBack}
        onLoadRequest={onLoadRequest}
        additionalCanvasMenuItems={additionalCanvasMenuItems}
        additionalNodeMenuItems={additionalNodeMenuItems}
      />
    </ReactFlowProvider>
  );
};

export default EntitlementEditorWrapper;
export { RepositoryProvider, MockRepository };